import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { API_URLS } from '../constants/api-urls.constants';
import { BehaviorSubject, catchError, Observable, of, throwError } from 'rxjs';
import {v4 as uuid4} from 'uuid';
import { AuthTokenService } from './auth0-token.service';
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { W9AlertComponent } from '../../features/popups/processing/processing.component';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  urlToken: string = '';
  specialityDetailsCache: { [key: string]: { data: any, status: string } } = {};
  schoolDetailsCache: { [key: string]: { data: any, status: string } } = {};
  allRoles: any = [];
  private usernameSubject = new BehaviorSubject<string | null>(
    localStorage.getItem('username')
  );
  username$ = this.usernameSubject.asObservable();
  resourceURL = ""
  credentialing_graceperiod = ""
  credentialing_acceptattestation = "";
  constructor(private router: Router,private http: HttpClient, private tokenService:AuthTokenService,public dialog: MatDialog) { }


  updateUsername(username: string) {
    localStorage.setItem('username', username);
    this.usernameSubject.next(username); 
  }
  
  searchUser(payload: any): Observable<any> {
    return this.http.post(`${environment.userApiUrl}${API_URLS.USER_SEARCH_URL}`, payload)
  }

  createUser(payload: any): Observable<any> {
    return this.http.post(`${environment.userApiUrl}${API_URLS.USER_SAVE_URL}`, payload)
  }

  saveUser(payload:any):Observable<any> {
    return this.http.put(`${environment.userApiUrl}${API_URLS.USER_UPDATE_URL}`, payload) 
  }

  getRoles(pageSize: any, pageNo: any) {
    let roleApi = API_URLS.USER_ROLES + pageSize + '/' + pageNo;
    return this.http.get(`${environment.userApiUrl}${roleApi}`);
  }

  updateUser(payload: any): Observable<any> {
    return this.http.put(`${environment.userApiUrl}${API_URLS.USER_UPDATE_URL}`, payload)
  }
  updateAuth0User(payload: any): Observable<any> {
    return this.http.put(`${environment.userApiUrl}${API_URLS.UPDATE_PROFILE}`,payload)
    }
  setFooter(isLogin: boolean): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem("footerEntries") || isLogin) {
        const queryParam = this.urlToken != "" ? `&maintenanceModeToken=${this.urlToken}` : "";
        this.getCMSContent('footer' + 'Mo' + queryParam)
          .subscribe({
            next: (footerEntries: any) => {
              localStorage.setItem("footerEntries", JSON.stringify(footerEntries));
              resolve("done"); // Resolve the promise
            },
            error: (error: any) => {
              reject("error"); // Reject the promise
            }
          });
      } else {
        resolve("already exists");
      }
    });
  }

  getCMSContent(contentType: any) {
    let cmsApi = `/cms/contents?contentType=${contentType}`
    let userApiUrl = environment.cmsApiUrl
    return this.http.get(`${userApiUrl}${cmsApi}`);
  }
  
  preventNonNumeric(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);

    // Allow digits (ASCII: 48-57), backspace (8), and delete (46)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  preventNonNumericForDecimal(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
   
    if (
      !/[0-9.]/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }
  preventNonNumbericForPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') || '';

    if (!/^[0-9]+$/.test(pastedText)) {
      event.preventDefault();
    }
  }

  validateNPI(npi: any): Observable<any> {
    let npiApi = `${environment.validateNpiUrl}${API_URLS.VALIDATE_NPI_URL}${npi}`
    return this.http.post(`${npiApi}`, {})
  }

  getCredentialingRequestStatus(payload: any): Observable<any> {
    return this.http.post(`${environment.overjetUrl}${API_URLS.OVERJET_CREDENTALING_REQUEST_URL}`, payload)
  }
  
  searchCredentiallingData(payload: any): Observable<any> {
    return this.http.post(`${environment.credentialSearchApiUrl}${API_URLS.CREDENTIAL_SEARCH_URL}`, payload)
  }
  
  getCredentiallingData(payload: any): Observable<any> {
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.CREDENTIAL_GET_URL}`, payload)
  }

  formatDate(dateString: string): string {
    if (!!dateString) {
      const date = new Date(dateString);
      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();
      return `${month}/${day}/${year}`;
    }
    else {
      return "";
    }
  }

  formatDateString(dateInput: any){
  const dateString = dateInput?.toString();
  if (!dateString || dateString.length !== 8) return '';
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);
  return `${year}-${month}-${day}`;
  }

  startCredentialling(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.START_CREDENTIALING}`,payload)
  }
  saveWorkhistory(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_WORKHISTORY}`,payload)
  }
  saveLocation(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_LOCATION}`,payload)
  }
  saveAttestation(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_ATTESTATIONS}`,payload)
  }
  saveDirectory(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_DIRECTORY}`,payload)
  }

  getAuthToken(payload: any): Observable<any> {
    return this.http.post(`${environment.authTokenApi}${API_URLS.AUTH_TOKEN}`, payload)
  }
  getDdmoToken(){
    const auth0Token = localStorage.getItem('auth0_id_token');
    this.callToken(auth0Token).pipe(catchError((error:any)=>{
        return throwError(() => {
        }) 
      }))
      .subscribe((response:any)=>{
        let ddmoToken = response.ddmo?.accessToken
        localStorage.setItem('accessToken', ddmoToken)
      })
  }
  callToken(authToken: any): Observable<any> {
    const headers = new HttpHeaders({
        'Authorization': 'Bearer ' + authToken,
        'Content-Type': 'application/json'
      });
    return this.http.get(`${environment.userApiUrl}${API_URLS.TOKEN_URL}`, { headers })
  }
  setStorageAuth0(data:any, type:any){
    const tokens = data
        const payload = this.decodeAuth0Token(tokens.id_token)

        this.tokenService.saveTokens(tokens)
         localStorage.setItem('auth0_user_id', payload.sub);
         if(type == 'internal'){
          localStorage.setItem('internal_user_id', payload.internal_user_id);
          localStorage.setItem('logintype', 'admin')
         }else{
          localStorage.setItem('user_id', payload['https://deltadentalmo.com/user_id']);
          localStorage.setItem('logintype', 'dentist')
         }
         localStorage.setItem('user_email', payload.email);
        this.updateUsername(payload.name)
  }

  decodeAuth0Token(token:any){
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return payload

  }

  saveUserDetails(authToken:any) {
    let userId = 0;
    const claims = this.decodeAuth0Token(authToken)
    localStorage.setItem('loggedInUser', claims.given_name);
    this.getRoles(50, 1).subscribe((data: any) => {
      this.allRoles = data?.results;
      let roleName: any = '';
      roleName = claims['https://deltadentalmo.com/group']?.toLowerCase();
      this.searchUser({ emailAddress: claims.email, roleName: roleName })
      .pipe(
        catchError((error: any, _caught: Observable<any>): Observable<any> => {
          if (error.message != undefined) {
            let payload = this.setUser(
              claims, roleName
            );
            this.createUser(payload).subscribe({
              next: (response: any) => {
                this.searchUser({ emailAddress: claims.email, roleName: roleName }).subscribe({
                  next: (_data:any) => {
                    this.getUserData(_data,'admin')
                  },
                  error: (e: any) => {
                  }
                });
              },
              error: (e: any) => {}
            });
          }
          return of();
        })
      )
      .subscribe((_data: any) => {    
        if (_data.totalRecords != 0) {
          userId = _data['users'][0]['userId'];
          let payload = this.updateUserData(userId, 'admin');
          payload['userId'] = userId;
          
         this.updateUser(payload)
            .subscribe(() => {
              this.getUserData(_data,'admin')
            });
        }
      });
    });
    
  }

  setUser(idtoken: any, roleName:any) {
    let payload: any = {};
    payload['userName'] = idtoken.email;
    payload['emailAddress'] = idtoken.email;
    payload['firstName'] = idtoken.given_name;
    payload['lastName'] = idtoken.family_name;
    let roles: any = [];
      let matchingRoles = this.allRoles.filter((d: any) => d.RoleName == roleName);
      if (matchingRoles.length != 0) {
        let role = matchingRoles[0]['RoleID'];
        roles.push(role);
      }
    payload['roleId'] = roles;
    payload['lastLogin'] = this.formatUTCToCustom(new Date());
    let uuid=uuid4();
    localStorage.setItem("trailWebSessionId",uuid)
    payload['trailWebSessionId'] = uuid;
    payload['activeFlg'] = 1;
    payload['userStatusId'] = 1;
    payload['createdUserId'] = null;
    payload['modifiedUserId'] = null;
    return payload;
  }

  formatUTCToCustom(date:any) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    const milliseconds = String(date.getUTCMilliseconds()).padStart(3, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }

  updateUserData(userId: any, roleType:string = '', tokenDetails:any = {}) {
    let payload: any = {};
    let latest_date = this.formatUTCToCustom(new Date());
    payload['userId'] = userId;
    payload['modifiedUserId'] = userId; 
    payload['modifiedDate'] = latest_date;
    payload['setLoginDate'] = true;
    payload['activeFlg'] = 1;
    let uuid=uuid4();
    localStorage.setItem("trailWebSessionId",uuid)
    payload['trailWebSessionId'] = uuid;
    return payload;
  }
  getUserData(payload:any, userType:any=''){


    let result = payload["users"][0];
    localStorage.setItem("firstName", result["firstName"]);
    localStorage.setItem("lastName", result["lastName"]);
    localStorage.setItem("licensestate", result["licenseState"]);
    localStorage.setItem("licensenumber", result["licenseNumber"]);
    localStorage.setItem("npi", result["npi"]);
    localStorage.setItem("userName", result["username"]);
    localStorage.setItem("loginUserId",  result["userId"]);
    localStorage.setItem("loginUserOperations", JSON.stringify(result.roles[0].operations));
    let auditLog:any={};
    auditLog["websiteCodeId"] = 50;
    auditLog["trailType"]='Search';
    auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
    auditLog["absolutePath"]=this.router.url.includes('?')? this.router.url.split('?')[0]: this.router.url;
    let userId = parseInt(localStorage.getItem("loggedUserId")!);
    auditLog["userId"] = result["userId"] ? result["userId"] : 0
    auditLog["impersonateId"]=0;
    auditLog["firstName"]=`${result.firstName}`;
    auditLog["lastName"]=`${result.lastName}`;
    this.logWebTrailSearch(auditLog).subscribe(data=>{
    });
  }

  preventNumeric(event: KeyboardEvent): void {
    const charCode = event.key.charCodeAt(0);
   
    // Allow only A-Z (65–90) and a-z (97–122)
    if (
      (charCode < 65 || charCode > 90) &&
      (charCode < 97 || charCode > 122)
    ) {
      event.preventDefault();
    }
  }

  getUserDetails(email:any){
    return this.http.get(`${environment.userApiUrl}${API_URLS.GET_USER_DETAIL}?emailAddress=${email}`);
  }
  
  deleteCredentialApplication(payload:any){
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.DELETE_CREDENTIALAPP}`,payload)
  }
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value || '';
  
      // If the field is completely empty, let 'Validators.required' handle it
      if (!value.length) {
        return null;
      }
      if (value.trim().length === 0) {
        return { whitespace: true };
      }
      return null;
    };    
  }
  validateData(data: {userId:number; licenseNumber:string; npi:string}):Observable<any>{
    return this.http.post(`${environment.overjetUrl}${API_URLS.VALIDATE_DATA}`,data)
  }
  getAttestationQuestions() {
    return this.http.get(`${environment.credentialGetApiUrl}${API_URLS.ATTESTATION_QUESTIONS}`);
  }
  submitCredentialApplication(payload: any) {
    return this.http.post(`${environment.overjetUrl}${API_URLS.SUBMIT_CREDENTIAL_APPLICATION}`, payload)
  }
  saveTelemetricLogs(payload: any) {
    return this.http.post(`${environment.telemetricUrl}${API_URLS.ERROR_LOG}`, payload)
  }
  logError(eventName: string, methodName: string, pageUrl: string,  error: any):any{
    const payload = {
      eventName: eventName,
      methodName: methodName,
      pageUrl: pageUrl,
      userId: localStorage.getItem("user_id")?? "",
      errorMessage: error?.message ?? 'Unknown error'
    };
    return this.saveTelemetricLogs(payload);
  }
  logWebTraillog(payload: any): Observable<any> {
    const url = `${environment.userAuditUrl}${API_URLS.WEB_TRAIL_LOG}`;
    return this.http.post(url, payload);
  }
   logWebTrailSearch(payload: any): Observable<any> {
    const url = `${environment.userAuditUrl}${API_URLS.WEB_TRAIL_SEARCH}`;
    return this.http.post(url, payload);
   }
   callUserAudit(path:any){
    let auditLog:any={};
    auditLog["websiteCodeId"] = 50;
    auditLog["trailType"]='Trail';
    auditLog["trailWebSessionId"]=localStorage.getItem("trailWebSessionId")?.toUpperCase();
    auditLog["absolutePath"]=path;
    const impersonatedUser = localStorage.getItem("impersonatedUser") ?? ""
    if(impersonatedUser){
      let adminUserId = parseInt(localStorage.getItem("loginUserId")!);
      let impersonatedUserId = parseInt(localStorage.getItem("impersonatedUserId")!);
      auditLog["userId"] = adminUserId ? adminUserId : 0
      auditLog["impersonateId"]= impersonatedUserId?impersonatedUserId:0;
    }else{
      let userId = parseInt(localStorage.getItem("loggedUserId")!);
      auditLog["userId"] = userId ? userId : 0
      auditLog["impersonateId"]=0;
    }
    auditLog["notes"]= "";
    this.logWebTraillog(auditLog).subscribe(data=>{
    });
  }

  validateFormLimits(form: FormGroup, FIELD_LIMITS: any): boolean {
    let isValid = true;
   
    const normalizeValue = (value: any, config: any) => {
      if (!config.ignoreSymbols) return value;
   
      if (typeof value === 'string') {
        return value.replace(/[$,\s]/g, ''); // remove $, commas, spaces
      }
   
      return value;
    };
   
    Object.keys(FIELD_LIMITS).forEach(key => {
      const control = form.get(key);
      if (!control) return;
   
      const config = FIELD_LIMITS[key];
      let value = control.value;
   
      if (value === null || value === undefined || value === '') return;
   
      value = normalizeValue(value, config);
   
      let errors: any = { ...(control.errors || {}) };
   
      // 🔹 STRING VALIDATION
      if (config.type === 'string') {
        if (typeof value !== 'string') value = String(value);
   
        if (config.maxLength !== undefined && value.length > config.maxLength) {
          errors['maxLength'] = true;
          isValid = false;
        }
      }
   
      // 🔹 NUMBER / DECIMAL VALIDATION
      if (config.type === 'number') {
        const numValue = Number(value);
   
        if (isNaN(numValue)) {
          errors['invalidNumber'] = true;
          isValid = false;
        } else {
          // max value check
          if (config.maxValue !== undefined && numValue > config.maxValue) {
            errors['max'] = true;
            isValid = false;
          }
   
          // precision check (e.g., DECIMAL(15,2))
          if (config.precision !== undefined) {
            const decimalPart = value.toString().split('.')[1];
            if (decimalPart && decimalPart.length > config.precision) {
              errors['precision'] = true;
              isValid = false;
            }
          }
        }
      }
   
      // 🔹 Apply errors (without wiping others)
      if (Object.keys(errors).length > 0) {
        control.setErrors(errors);
      }
    });
   
    return isValid;
  }

  searchTIN(data:any):Observable<any>{
  return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SEARCH_TIN}`,data)
}
  addTin(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.ADD_TIN}`,payload)
  }
  saveLocationPayeeTax(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.SAVE_LOCATION_PAYEE_TAX}`,payload)
  }
  getW9UploadStatus(payload:any):Observable<any>{
    return this.http.post(`${environment.credentialGetApiUrl}${API_URLS.GET_W9_STATUS}`,payload)

  }
  deleteLocationFailedPopupCall(isDelete?:any, message?:any){
    let alertMessage;
    if(isDelete && message == 'location'){
      alertMessage = "Failed to delete location. Please try again.";
    }else if(isDelete && message == 'tin'){
      alertMessage = "Failed to delete tin. Please try again.";
    }else if(!isDelete && message == 'saveTin'){
      alertMessage = "Failed to save TIN. Please try again.";
    }else{
      alertMessage = "Failed to save location. Please try again.";
    }
    let dialogRef=   this.dialog.open(W9AlertComponent, {
        disableClose: true,
         data: { message: alertMessage},
         width: '550px',
         backdropClass: '',
         hasBackdrop: true,
       });
       dialogRef.afterClosed().subscribe((result:any) => {
       });
  }
  getTinDetails(payload:any){
    const url = `${environment.credentialGetApiUrl}/credentialing/location-payee-tin`;
    return this.http.post(url, payload);
  }
}
